import React from 'react';
import OutputText from '@ey/canvascoreservices/OutputText';

export const idColumn = {
	id: 'idColumn',
	label: 'ID',
	propName: 'id',
	width: 'var(--px-200)',
	customCell: (item) => <OutputText size="XL">{item.id} (custom)</OutputText>,
	sortBy: 'id'
};

export const nameColumn = {
	id: 'nameColumn',
	label: 'Name jhkjgkjg kjg kjg kj kjg kj gkjg j fdhfds fdhjhgf hgf hf h gfhg h gfhg fhg',
	propName: 'name',
	width: 'var(--px-200)',
	sortBy: ['name', 'description']
};

export const descColumn = {
	id: 'descColumn',
	label: 'Description',
	propName: 'description',
	width: 'minmax(var(--px-200), 1fr)',
	sticky: 'left',
	stickyPosition: '0',
};
